import { InfrastructureResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/responseSchema";
import { BatchPreview } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/batchSections/BatchPreview";
import { FormInputs } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/batchSections/FormInputs";
import { SubTypeInput } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/batchSections/SubTypeInput";
import { TrickFormHookGroupedTrainFormSchema } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { OperationalInformationTypes } from "features/CenterContent/shared/operationalInformation/hooks/useOperationalInformationTypes";
import { FC } from "react";

export type TrainInfoBatchFormProps = {
  opInfoTypes: OperationalInformationTypes;
  infrastructureEvent?: InfrastructureResponse; // undefined only in ProductionDeviation
  activeTrainSeriesKey: keyof TrickFormHookGroupedTrainFormSchema;
  groupsInSeries: number;
  mode: "create" | "edit";
  lockEventType?: boolean;
};

const TrainInfoBatchForm: FC<TrainInfoBatchFormProps> = ({ ...props }) => (
  <>
    <FormInputs {...props} />
    <SubTypeInput {...props} />
    <BatchPreview {...props} />
  </>
);

export { TrainInfoBatchForm };
